/**
 * 聊天相关的类型定义
 */

// 消息类型枚举
export enum MessageType {
    USER = "user", // 用户消息
    AI = "ai", // AI消息
    SYSTEM = "system", // 系统消息
  }
  
  // 消息状态枚举
  export enum MessageStatus {
    SENDING = "sending", // 发送中
    SENT = "sent", // 已发送
    FAILED = "failed", // 发送失败
    RECEIVED = "received", // 已接收
  }
  
  // 单条消息接口
  export interface ChatMessage {
    id: string;
    content: string;
    translatedContent?: string; // 译文
    translatedLang?: string; // 译文语言
    translated?: boolean; // 是否已翻译过
    globalTranslation?: boolean; // 🔧 是否在全局翻译开启后的消息
    type: MessageType;
    status: MessageStatus;
    timestamp: number;
    avatar?: string;
    username?: string;
    isTyping?: boolean; // 是否正在打字
    msgId?: number; // WebSocket消息ID，用于流式消息累积
    isLoadingTranslate?:boolean;
    generatedImageUrl?: string; // 生图结果地址（由 socket 或接口回写）
    image?: string; // 生图图片地址（由 socket 或接口回写）
    isSuccessful?: boolean; // 生图是否成功（true=成功，false=失败，undefined=未生图或生图中）
    hasGeneratedImage?: boolean; // 是否已生成过图片
    isGeneratingImage?: boolean; // 是否正在生成图片
    [key: string]: any;
  }
  
  // 聊天会话接口
  export interface ChatSession {
    id: string;
    name: string;
    messages: ChatMessage[];
    createdAt: number;
    updatedAt: number;
    avatar?: string;
    lastMessage?: string;
  }
  
  // AI聊天请求接口
  export interface ChatRequest {
    message: string;
    sessionId?: string;
    context?: ChatMessage[]; // 上下文消息
  }
  
  // AI聊天响应接口
  export interface ChatResponse {
    id: string;
    content: string;
    sessionId: string;
    timestamp: number;
  }
  
  // 聊天配置接口
  export interface ChatConfig {
    model?: string; // AI模型
    temperature?: number; // 温度参数
    maxTokens?: number; // 最大token数
    stream?: boolean; // 是否流式输出
  }
  
  export const timeoutPromptWord = [
    "Hey, no rush! 😊 I'm just mulling over some sweet words for you. 🌸",
    "Like we're just kicking back and chatting—hang on a sec, okay? 🤗⏳",
    "I wanna get this right, so I'm pondering with a smirk! 😏💭",
    "Hey, while you chill, I'm cooking up some flirty vibes for you! 😏🔥",
    "This little pause? It's like a fun beat drop—bring on the next thrill! 🎶😉",
    "Aww, thanks for being patient—you're in for a spicy reply! 😏🔥",
  ];
  